{
  "common": {
    "exclusiveSector": "Exclusive intervention sector: Asnières-sur-Seine, Neuilly-sur-Seine, Levallois and immediate surroundings.",
    "exclusiveSectorPrefix": "Exclusive intervention sector:",
    "exclusiveSectorSuffix": " Asnières-sur-Seine, Neuilly-sur-Seine, Levallois and immediate surroundings."
  },
  "navbar": {
    "method": "The Method",
    "packages": "Our Packages",
    "team": "The Team",
    "clientArea": "Client Portal",
    "audit": "Book an appointment",
    "portfolio": "Our work"
  },
  "hero": {
    "subtitle": "High-End Concierge & Housekeeping",
    "title1": "Excellence,",
    "title2": "Without Compromise.",
    "desc": "An exclusive housekeeping service for the most demanding interiors. Absolute confidentiality, elite staff, and rigorous oversight by our founder.",
    "btnEstimate": "Estimate My Package",
    "btnMethod": "Discover the Method",
    "btnJoin": "Join a package"
  },
  "calculator": {
    "sectionTag": "Your Personalized Study",
    "sectionTitle": "Configure your package",
    "step1": "Level of Requirement",
    "step2": "The Property",
    "step3": "Specifics & Requirements",
    "perHour": "/ h",
    "afterTax": "After 50% tax credit",
    "grossPerHour": "{{price}}€ / h gross",
    "surface": "Surface Area",
    "surfaceUnit": "sqm",
    "roomsLabel": "Living Rooms",
    "bathroomsLabel": "Bathrooms",
    "kitchensLabel": "Kitchens",
    "note": "Note: External dry cleaning costs or the amount of grocery shopping remain entirely the customer's responsibility and will be re-invoiced to the nearest euro, without margin.",
    "studySummary": "Your Study",
    "estimatedTime": "Estimated time",
    "timeUnit": "h / week",
    "serviceLevel": "Service level",
    "grossMonthly": "Gross Monthly Package",
    "advanceBadge": "Immediate advance -50%",
    "netMonthly": "Net Monthly Package",
    "btnAudit": "Request an audit",
    "noCommitment": "Indicative estimate without commitment",
    "packages": {
      "essentiel": {
        "name": "Premium Essential",
        "desc": "Deep cleaning with high-end ecological products."
      },
      "signature": {
        "name": "Signature Home",
        "desc": "Includes fine linen management, ironing, and organization."
      },
      "intendance": {
        "name": "Absolute Stewardship",
        "desc": "VIP Concierge, care of rare materials, shopping, and logistics."
      }
    },
    "specifics": {
      "pets": {
        "label": "Pets",
        "desc": "Hair management, special precautions"
      },
      "children": {
        "label": "Young Children",
        "desc": "Gentle disinfection, meticulous tidying"
      },
      "art": {
        "label": "Artworks & Collections",
        "desc": "Delicate dusting, no chemicals"
      },
      "marble": {
        "label": "Noble Materials",
        "desc": "Marble, brass, solid wood, leather"
      },
      "dressing": {
        "label": "Dressing & Linen",
        "desc": "Marie Kondo folding, dry cleaning management"
      },
      "silver": {
        "label": "Silverware & Crystalware",
        "desc": "Hand washing and polishing"
      },
      "groceries": {
        "label": "Grocery Management",
        "desc": "Fresh product supply"
      },
      "plants": {
        "label": "Plants & Balconies",
        "desc": "Plant care, regular watering"
      }
    },
    "vipFrom": "Starting from",
    "vipText": "Every interior is unique and deserves special attention. To confirm this exact rate and design your specifications, ",
    "vipAction": "book your free in-home audit below."
  },
  "taxCredit": {
    "title": "Immediate Advance: Zero Paperwork",
    "subtitle": "Enjoy an instant 50% tax credit. We handle all the administration for you.",
    "step1Title": "Simplified Registration",
    "step1Desc": "Johanna takes care of creating your URSSAF personal services account.",
    "step2Title": "Validation",
    "step2Desc": "You will receive a simple email from URSSAF. One click is all it takes to activate your account.",
    "step3Title": "Divided Direct Debit",
    "step3Desc": "Each month, URSSAF deducts only 50% of the invoice from your account. The State pays the rest."
  },
  "legal": {
    "mentions": {
      "title": "Legal Notice",
      "content": "Publisher: L'art du Ménage par Johanna.\nHeadquarters: Asnières-sur-Seine.\nPublication Director: Johanna.\nHosting: Vercel / Netlify."
    },
    "privacy": {
      "title": "Privacy Policy",
      "content": "Confidentiality is our absolute priority. All collected data (floor plans, home specifics, addresses) are encrypted and protected by strict Non-Disclosure Agreements (NDA)."
    },
    "cgv": {
      "title": "Terms & Conditions",
      "content": "All services are subject to quote acceptance after an on-site audit. Cancellations must be notified 48 hours in advance."
    }
  },
  "faq": {
    "title": "FAQ & Tax Credit",
    "q1": "How does the Immediate Advance work?",
    "a1": "We register you with URSSAF. You only pay 50% of the invoice each month; the State directly pays the rest.",
    "q2": "Who works in my home?",
    "a2": "Hand-picked professionals trained in luxury hospitality, with clear criminal records, operating under strict confidentiality agreements.",
    "q3": "What happens in case of damage?",
    "a3": "We carry a specific Professional Civil Liability insurance covering very high-value items."
  },
  "linge": {
    "title": "Laundry & Wardrobe Care",
    "subtitle": "Treatment worthy of grand hotels",
    "desc": "Perfect ironing, precise folding, and utmost respect for noble fabrics (silk, cashmere). Your wardrobe is methodically organized.",
    "detailTitle": "The Demand for Detail"
  },
  "engagements": {
    "heroTag": "Our Trust Contract",
    "heroTitle1": "Our",
    "heroTitle2": "Commitments",
    "introTitle": "Intransigence at the service of your serenity.",
    "introDesc": "Entering the intimacy of your home is a privilege we honor with absolute standards. At <strong class=\"text-black-deep font-serif\">L'Art du Ménage par Johanna</strong>, we make no concessions on ethics, security, and quality. Our commitments are not mere commercial promises, they are the unshakable foundations of our method.",
    "ctaTag": "Join the circle",
    "ctaTitle": "Ready to delegate with confidence?",
    "ctaDesc": "Request your private audit to jointly define the specifications for your interior.",
    "ctaBtn": "Book an appointment",
    "commitments": [
      {
        "title": "Absolute Discretion",
        "desc": "True luxury is silent. Our housekeepers sign a strict non-disclosure agreement (NDA). Your private life stays behind closed doors. No information, no photos (except secure reports) are leaked."
      },
      {
        "title": "High-Performance Ecology",
        "desc": "We ban toxic chemistry. We exclusively use certified ecological solutions, natural waxes, and essential oils that preserve your health, your noble materials, and the environment."
      },
      {
        "title": "Zero Defect Guarantee",
        "desc": "Human error exists, the demand for perfection corrects it. If a service does not meet our standards or your specifications, we intervene again within 24 hours, at our expense. Excellence is not an option."
      },
      {
        "title": "Elite Staff",
        "desc": "Our staff are recruited according to Parisian palace criteria. Continuously trained in luxury hospitality, they are also paid well above market standards to guarantee their loyalty and commitment."
      },
      {
        "title": "Infallible Security",
        "desc": "Your trust is our greatest capital. Keys entrusted are anonymized and stored in a biometric safe. The criminal records (Casier B3) of all our employees are verified before hiring."
      },
      {
        "title": "Total Transparency",
        "desc": "A detailed photographic report after each visit, clear invoicing with no hidden costs, and immediate handling of the URSSAF immediate tax credit advance. We manage everything, you keep control."
      }
    ]
  },
  "home": {
    "founder": {
      "tag": "A word from the founder",
      "title1": "The obsession with",
      "title2": "perfect detail.",
      "p1": "After years of noticing the lack of rigor in traditional housekeeping services, I decided to create the service I couldn't find for my own home.",
      "p2": "I am what you might call a perfectionist. For me, housekeeping is not a chore, it's an art. The art of enhancing noble materials, the art of preserving a healthy environment, and above all, the art of absolute discretion.",
      "p3": "This is why I personally audit every new property and conduct weekly surprise inspections. My exacting standards are your greatest guarantee.",
      "name": "JOHANNA",
      "role": "Director & Founder",
      "alt": "Johanna, Founder"
    },
    "features": {
      "tag": "Unconditional Guarantee",
      "title1": "The Art of",
      "title2": "Excellence",
      "desc": "Four fundamental pillars that redefine the standards of prestigious in-home service. We make no compromises on perfection.",
      "scroll": "Discover our promises",
      "items": [
        {
          "title": "Elite",
          "titleItalic": " Housekeepers",
          "desc": "All our housekeepers speak perfect French and have many years of experience in luxury hospitality or maintaining prestigious residences. Approximation has no place here."
        },
        {
          "title": "Absolute",
          "titleItalic": " Confidentiality",
          "desc": "Systematic signing of a Non-Disclosure Agreement (NDA) beforehand. Your privacy is a sanctuary we preserve with rigorous silence."
        },
        {
          "title": "Obsessive",
          "titleItalic": " Oversight",
          "desc": "Excellence is never left to chance. Surprise inspections ensure meticulous and systematically perfect execution of our maintenance protocols."
        },
        {
          "title": "Tax",
          "titleItalic": " Optimization",
          "desc": "The elegance of a high-end service coupled with financial intelligence. Instantly benefit from a 50% tax advantage with no upfront cash."
        }
      ]
    },
    "exclusivity": {
      "title1": "Absolute Standard",
      "title2": "A House",
      "title3": "Reserved for the Elite",
      "tag": "Private Circle",
      "p1": "L'Art du Ménage is not a simple cleaning company. It is a private institution dedicated to perfection.",
      "p2": "We have chosen absolute quality over quantity. Our housekeepers are detail experts, trained to meet the highest standards. Because your home is precious, we only provide the best of our expertise.",
      "btn": "Request a Membership",
      "items": [
        {
          "title": "Rigorous Selection",
          "desc": "We do not accept all requests. We prioritize recommended clients and those who share our vision of refinement and respect."
        },
        {
          "title": "Manic Work",
          "desc": "Our approach is meticulous, almost obsessive. Every corner, every surface is treated with uncompromising perfection."
        },
        {
          "title": "The Price of Exception",
          "desc": "Unmatched service quality requires a corresponding rate. Our services are designed for an elite that refuses compromise."
        }
      ]
    },
    "timeline": {
      "tag": "Excellence Step by Step",
      "title": "Our Methodology",
      "items": [
        {
          "title": "The Initial Audit",
          "desc": "Meeting with Johanna at your home to understand your requirements, list the property's specifics, and choose the appropriate package."
        },
        {
          "title": "Contract & Discretion",
          "desc": "Signing of the service contract and Non-Disclosure Agreement (NDA). Your keys are secured and anonymized."
        },
        {
          "title": "Elite Services",
          "desc": "Intervention by our providers trained in strict protocols, with real-time tracking via the client area (post-intervention photos)."
        },
        {
          "title": "Quality Control",
          "desc": "Surprise visits by Johanna during or after interventions to guarantee a constant level of perfection."
        }
      ]
    }
  },
  "methode": {
    "heroTag": "Excellence as a Doctrine",
    "heroTitle1": "Our",
    "heroTitle2": "Method",
    "manifestoTag": "The Manifesto",
    "manifestoTitle1": "The art of housekeeping",
    "manifestoTitle2": "cannot be improvised.",
    "manifestoP1": "It demands military precision combined with absolute delicacy. We don't just clean; we restore the perfect harmony of your home.",
    "manifestoP2": "Every action of our elite providers is codified, anticipated, and measured. Each high-end ecological product is rigorously selected for its surgical efficiency and absolute respect for your most precious materials.",
    "manifestoP3": "We consider true cleanliness to be invisible: it is the total absence of flaws, the subtle scent of cleanliness, and the perfect order that reigns after our visit.",
    "protocolTag": "The 8 Golden Rules",
    "protocolTitle": "The Protocol",
    "protocolDesc": "Click on each rule to delve into our specifications and discover the required level of detail.",
    "modalTag": "Golden Rule",
    "recruitmentTag": "Only 3% success rate",
    "recruitmentTitle1": "Training the",
    "recruitmentTitle2": "Elite",
    "recruitmentDesc": "After drastic selections, our candidates undergo intensive 4-week training on strict luxury hotel protocols before their very first intervention.",
    "recruitmentBtn": "Apply to join us",
    "rules": [
      {
        "title": "Systematic Disinfection",
        "subtitle": "Hospital-grade hygiene for your touchpoints.",
        "detail": "Switches, door handles, remote controls, and faucets are disinfected with high-performance, hospital-grade ecological products. We pay obsessive attention to invisible areas, often neglected by standard services, to guarantee a perfectly sanitary environment."
      },
      {
        "title": "Exclusive Microfibers",
        "subtitle": "Strict anti-cross-contamination protocol.",
        "detail": "Our color-coding is uncompromising (red for bathrooms, blue for living areas, etc.). Each microfiber is used only for one specific area of your home. This ensures absolute hygiene and eliminates any risk of cross-contamination between rooms."
      },
      {
        "title": "Palace Standard (Laundry)",
        "subtitle": "The art of Marie Kondo folding.",
        "detail": "Your towels and clothes are handled with white gloves, then folded to the millimeter according to the Marie Kondo method and strict Parisian palace standards. We ensure perfect geometric alignment in your drawers and closets."
      },
      {
        "title": "Air Purification",
        "subtitle": "Breathing and olfactory signature.",
        "detail": "We perform a complete air renewal in each room throughout the intervention. The operation concludes with a subtle vaporization of our exclusive olfactory signature, leaving behind a sensation of immediate purity."
      },
      {
        "title": "Care of Noble Materials",
        "subtitle": "Expertise on marble, wood, and leather.",
        "detail": "No generic cleaning product is tolerated here. We exclusively use high-end nourishing balms for your leathers, natural wax for your rare woods, and perfectly neutral pH solutions to preserve the original shine of your marbles."
      },
      {
        "title": "Symmetrical Arrangement",
        "subtitle": "Restoring visual harmony.",
        "detail": "Every object, book, or trinket moved for cleaning is put back exactly in its place. We pay manic attention to the symmetry of your cushions, the alignment of your chairs, and the perfect drape of your curtains. Your interior regains its balance."
      },
      {
        "title": "15-Minute Inspection",
        "subtitle": "The silent quality control.",
        "detail": "Before leaving the premises, the housekeeper stops. She performs a silent and meticulous 15-minute quality control, crossing her expert gaze with an uncompromising digital checklist comprising over 40 mandatory checkpoints."
      },
      {
        "title": "Secure Photo Report",
        "subtitle": "Proof of excellence via your VIP area.",
        "detail": "Trust does not exclude control. Once our intervention is validated, you receive a discreet notification in your private client portal. There, you will find a photographic report proving the excellence of the work accomplished in each of your rooms."
      }
    ]
  },
  "forfaits": {
    "heroTag": "Priced Excellence",
    "heroTitle1": "Our",
    "heroTitle2": "Packages",
    "pricingTag": "A bespoke service",
    "pricingTitle": "Haute Couture of Housekeeping",
    "pricingDesc": "Three levels of standard to meet your lifestyle requirements. Hourly rates calculated per hour, adjusted by surface area in our simulator.",
    "popular": "Most requested",
    "grossPrice": "Gross rate:",
    "netPrice": "/ h net*",
    "netPriceDisclaimer": "*After 50% immediate tax credit",
    "btnAudit": "Request an Audit",
    "taxTag": "Tax Advantage",
    "taxTitle1": "Immediate Advance:",
    "taxTitle2": "Zero Paperwork.",
    "taxP1": "Enjoy 50% instant tax credit.",
    "taxP2": "Forget tedious declarations and waiting for next year's reimbursement. The state instantly finances 50% of your invoices. <strong class=\"text-white font-normal\">We fully manage the administration for you.</strong> You only pay the remainder.",
    "taxFeature1Title": "No hassle",
    "taxFeature1Desc": "We create your URSSAF account.",
    "taxFeature2Title": "1-click validation",
    "taxFeature2Desc": "Approve via SMS or email.",
    "taxExample": "Example: Monthly Invoice",
    "taxState": "URSSAF coverage (50%)",
    "taxRemaining": "Remaining balance",
    "taxRemainingSub": "Debited from your account",
    "packages": [
      {
        "name": "Essential Premium",
        "desc": "Everyday excellence for a perfectly kept interior.",
        "features": [
          "Thorough cleaning of all rooms",
          "Vacuuming and washing of hard floors",
          "Dusting of standard furniture",
          "Complete disinfection of bathrooms",
          "Use of our ecological products"
        ]
      },
      {
        "name": "Signature Home",
        "desc": "The art of care extended to your wardrobe and linens.",
        "features": [
          "Everything in Essential Premium",
          "Expert management of household linens",
          "Professional on-site ironing",
          "Marie Kondo folding & wardrobe organization",
          "Regular changing of bed linens"
        ]
      },
      {
        "name": "Absolute Stewardship",
        "desc": "The 5-star private concierge for a freed mind.",
        "features": [
          "Everything in Signature Home",
          "Specific care of noble materials (marble, wood, leather)",
          "Delicate dusting of artworks",
          "Errand and dry cleaning management",
          "Package reception & provider coordination"
        ]
      }
    ]
  },
  "audit": {
    "heroTitle": "Request an Audit",
    "heroSubtitle": "Your Personalized Study",
    "errorIncomplete": "Please fill out all required fields (Name, Email, Phone, Address).",
    "errorSend": "An error occurred during transmission.",
    "errorAlert": "An error occurred while sending your request. Our teams have been notified.",
    "successTitle": "Request Confirmed",
    "successDesc": "We have received your request. Johanna will contact you shortly to schedule an appointment.",
    "formTitle": "Schedule the In-Home Audit",
    "formDesc": "Johanna will personally visit to assess the specifics of your property and establish a precise set of specifications.",
    "labelName": "Full Name",
    "labelPhone": "Phone",
    "labelEmail": "Email",
    "labelAddress": "Full Address",
    "labelProperty": "Property Type",
    "labelMessage": "Specific Message (Optional)",
    "propAppart": "Luxury Apartment",
    "propHouse": "House / Villa",
    "propMansion": "Mansion",
    "btnSubmit": "Request my Exclusive Audit",
    "btnLoading": "Processing..."
  },
  "recrutement": {
    "heroTitle": "Join the Elite",
    "heroSubtitle": "Recruitment",
    "errorIncomplete": "Please fill out all required fields.",
    "errorAlert": "An error occurred. Please try again.",
    "successTitle": "Application Received",
    "successDesc": "Johanna will review your profile with the utmost attention.",
    "formTitle": "Become a Housekeeper of Excellence",
    "formDesc": "We are looking for profiles with a keen eye for detail, trained to luxury hotel standards.",
    "labelName": "Full Name",
    "labelPhone": "Phone",
    "labelEmail": "Email",
    "labelExperience": "Years of experience in Hospitality / Manor Houses",
    "expSelect": "Select...",
    "exp1": "1 to 3 years",
    "exp2": "3 to 5 years",
    "exp3": "More than 5 years",
    "labelMotivation": "Your Motivations",
    "btnSubmit": "Submit my Application",
    "btnLoading": "Sending..."
  },
  "login": {
    "errorConfig": "Server configuration error.",
    "errorAuth": "Incorrect credentials or non-existent account.",
    "msgSuccess": "Connection successful. Opening your Privileged Area...",
    "errorEmailReq": "Please enter your email.",
    "errorReset": "Error sending the email.",
    "msgResetSuccess": "If this email exists, a reset link has just been sent to you.",
    "brandTitle": "L'ART DU MÉNAGE",
    "brandSubtitle": "by Johanna",
    "brandDesc": "Excellence does not stop at your doorstep. Find your photographic reports, invoices, and the status of your immediate URSSAF advance in your Privileged Area.",
    "formTitle": "Privileged Area",
    "formDescLogin": "Please log in to access your confidential documents.",
    "formDescReset": "Enter your email to reset your access password.",
    "labelEmail": "Contact Email",
    "labelPassword": "Access Password",
    "rememberMe": "Remember me",
    "forgotPass": "Forgot access?",
    "btnLoading": "Loading...",
    "btnLogin": "Access my area",
    "btnReset": "Reset",
    "backLogin": "Back to login",
    "footerNote": "Membership and account creation are done exclusively via audit by management.",
    "backHome": "Back to home"
  },
  "dashboard": {
    "brandArea": "PRIVILEGED AREA",
    "navDashboard": "Dashboard",
    "navInvoices": "My Invoices",
    "navReports": "Intervention Reports",
    "navSettings": "Settings",
    "navLogout": "Logout",
    "welcome": "Welcome",
    "accountOf": "Account of {{email}}",
    "urssafTitle": "Immediate URSSAF Advance",
    "urssafDesc": "Your URSSAF account is active and linked to L'Art du Ménage. The state covers 50% of your invoices instantly.",
    "urssafRemaining": "Remaining to pay this month",
    "nextIntervention": "Next Intervention",
    "nextStatus": "Pending scheduling",
    "nextDesc": "No intervention is planned in the next 7 days. Contact your concierge to schedule a visit.",
    "btnContact": "Contact Concierge",
    "reportsTitle": "Intervention Reports",
    "reportSample": "Report - June 2026",
    "reportDesc": "Before/After Photos • Complete checklist",
    "noMoreReports": "No other reports available.",
    "invoicesTitle": "Latest Invoices",
    "invoiceSample": "Invoice No. 2026-06-01",
    "invoiceDesc": "Processed via Immediate Advance",
    "noMoreInvoices": "No other invoices available."
  },
  "ville": {
    "headerTitle": "Your Concierge in {{cityName}}",
    "headerSubtitle": "Local Intervention",
    "sectionTitle": "Excellence in {{cityName}}",
    "desc1": "Because the residences of {{cityName}} require special attention, L'art du Ménage par Johanna deploys its elite teams in your area. Whether you live in a mansion or a luxury apartment, we apply our high-end concierge protocols with absolute discretion.",
    "desc2": "Take advantage of the proximity of our teams for a quick initial audit in {{cityName}}. Johanna personally travels to assess your needs."
  },
  "footer": {
    "brandTitle": "L'ART DU MÉNAGE",
    "brandSubtitle": "by Johanna",
    "brandDesc": "Everyday excellence. An exclusive concierge and cleaning service for the most demanding interiors.",
    "col1Title": "The House",
    "col1Mentions": "Legal Mentions",
    "col1Privacy": "Privacy Policy",
    "col1Cgv": "General Terms of Sale",
    "col2Title": "Our Services",
    "col2Packages": "Packages",
    "col2Laundry": "Laundry Care",
    "col2Zones": "Intervention Zones:",
    "col3Title": "Contact",
    "col3Vip": "VIP Client Area",
    "col3Faq": "FAQ & Tax Credit",
    "col3Commitments": "Our Commitments",
    "copyright": "© {{year}} L'art du Ménage par Johanna. All rights reserved.",
    "bottomMentions": "Legal mentions",
    "bottomPrivacy": "Privacy policy",
    "bottomCgv": "Terms of sale"
  },
  "faqPage": {
    "headerTitle": "Frequently Asked Questions",
    "headerSubtitle": "Support, Transparency & Legal Framework",
    "themes": "Themes",
    "data": [
      {
        "category": "Immediate URSSAF Advance",
        "items": [
          {
            "q": "What is the Immediate Tax Credit Advance?",
            "a": "It is an optional and free service implemented by URSSAF. It allows you to immediately deduct your 50% tax credit from your Personal Services invoices. You only pay your out-of-pocket costs."
          },
          {
            "q": "How to activate this service?",
            "a": "During our initial audit, if you are eligible, we create your URSSAF account. You will receive an email to activate your account. Everything is automated."
          },
          {
            "q": "Do I have to do any administrative paperwork?",
            "a": "No, L'Art du Ménage takes care of all declarations. You only have to validate our direct debit request on your URSSAF portal."
          },
          {
            "q": "Who debits the invoice amount?",
            "a": "URSSAF debits your remaining balance (50% of the invoice) directly from your bank account 2 days after the invoice is validated."
          },
          {
            "q": "Is there a ceiling for the tax credit?",
            "a": "Yes, the annual spending cap is €12,000, which can be increased depending on your household composition (dependents, elderly people). That means a maximum of €6,000 reduction per year."
          },
          {
            "q": "What happens if the URSSAF platform is down?",
            "a": "In the event of a technical failure at URSSAF, the entire invoice remains due to L'Art du Ménage. We will provide you with a tax certificate to recover your 50% the following year."
          },
          {
            "q": "Is this service only for taxable persons?",
            "a": "Absolutely not. It is a tax credit. If you do not pay taxes or if the amount of your taxes is less than your credit, the tax administration will reimburse you the difference."
          }
        ]
      },
      {
        "category": "Methodology & Services",
        "items": [
          {
            "q": "What are your golden rules?",
            "a": "We apply 8 golden rules inspired by luxury hotels: disinfection, specific microfibers, care for noble materials, aeration protocol, respect for symmetry, 15-minute inspection, and detailed report."
          },
          {
            "q": "Do you provide the equipment?",
            "a": "Yes. Our housekeepers come with their own state-of-the-art equipment, including a color-coded microfiber set to prevent cross-contamination, and very high-end eco-friendly products."
          },
          {
            "q": "Do you use toxic products?",
            "a": "No. We ban heavy chemicals. We use natural solutions, essential oils, and waxes suitable for rare materials (marble, solid wood, leather)."
          },
          {
            "q": "Can I require my own products to be used?",
            "a": "Yes, if you have specific requirements (e.g., for an artwork or antique furniture), we will scrupulously follow your instructions noted during the audit."
          },
          {
            "q": "How long does a service take?",
            "a": "It depends on your package and the initial audit. We do not charge strictly by the hour but by the result, although we estimate an hourly envelope for our housekeepers' planning."
          },
          {
            "q": "Is it always the same person who comes?",
            "a": "Yes. Except for vacations or illness, a dedicated housekeeper is responsible for your interior to guarantee perfect knowledge of your habits."
          },
          {
            "q": "Do you do ironing and dressing?",
            "a": "Basic ironing is included in our Signature Package. For expert organizing (by colors, seasons, template folding), we offer dedicated services."
          },
          {
            "q": "What does the 15-minute final inspection cover?",
            "a": "At the end of each service, the housekeeper stops cleaning and dedicates 15 minutes solely to visual inspection, adjusting cushions, aligning objects, and checking reflections."
          }
        ]
      },
      {
        "category": "Security & Confidentiality",
        "items": [
          {
            "q": "How do you manage my keys?",
            "a": "Your keys are anonymized (no name or address on them) and stored in a biometric safe. They are only taken out on the day of the service."
          },
          {
            "q": "Are your employees vetted?",
            "a": "Recruitment is drastic. We require a clean criminal record (B3), verifiable references, and training in total discretion."
          },
          {
            "q": "Do you sign a confidentiality agreement (NDA)?",
            "a": "Yes, all our employees sign a very strict Non-Disclosure Agreement. Your privacy, your identity, and the inside of your home remain secret."
          },
          {
            "q": "What is the photographic report?",
            "a": "Via your VIP area, you receive a report after each visit with photos of critical areas (before/after). These photos are encrypted and deleted regularly."
          },
          {
            "q": "What happens if a valuable object is broken?",
            "a": "We have specific high-end Professional Civil Liability insurance. In the event of breakage (reported within 48h), our insurance takes over."
          },
          {
            "q": "Is the housekeeper allowed to use their phone?",
            "a": "The use of a personal phone is strictly forbidden during the service, except to generate the encrypted photographic report via our business application."
          }
        ]
      },
      {
        "category": "Billing & Contracts",
        "items": [
          {
            "q": "Is the initial audit chargeable?",
            "a": "No, the physical audit of your home (or via video conference) to establish your specifications is completely free and without obligation."
          },
          {
            "q": "Is there a time commitment?",
            "a": "Our recurring packages are without time commitment after the first trial month, with a simple 30-day notice of termination."
          },
          {
            "q": "How to cancel or postpone a service?",
            "a": "You can postpone via your private concierge. We require a 48-business-hour notice. Any late cancellation incurs a 50% charge."
          },
          {
            "q": "Are there any hidden admin fees?",
            "a": "None. Our prices are net. The creation of the URSSAF account, administrative management, and travel are included in your packages."
          },
          {
            "q": "How do I access my invoices?",
            "a": "They are all available and downloadable in PDF format from your secure Privileged Area."
          }
        ]
      },
      {
        "category": "Concierge & Options",
        "items": [
          {
            "q": "Do you offer an external dry cleaning service?",
            "a": "Yes, our 'Laundry & Dry Cleaning Care' service includes collecting and delivering your delicate pieces to excellent partner dry cleaners."
          },
          {
            "q": "Can you receive packages in my absence?",
            "a": "This is possible as part of the Absolute Package (Concierge), provided that it takes place during our intervention hours."
          },
          {
            "q": "Do you do grocery shopping?",
            "a": "We can manage the restocking of your basic products (fridge, delicatessen, fresh flowers) as an option via our stewardship service."
          },
          {
            "q": "Do you intervene for emergencies or after a reception?",
            "a": "We offer a 'Day After Reception' service for our clients on a package, to restore your interior to its initial state after a private event."
          }
        ]
      }
    ]
  },
  "cgvPage": {
    "headerTitle": "General Terms of Sale",
    "headerSubtitle": "Personal Services",
    "lastUpdate": "Last updated: {{date}}",
    "art1Title": "Article 1 - Purpose and Scope",
    "art1P1": "These General Terms of Sale (CGV) define the rights and obligations of the parties in connection with the sale of home maintenance and concierge services offered by <strong>L'Art du Ménage par Johanna</strong> (hereinafter \"the Service Provider\") to the client (hereinafter \"the Client\").",
    "art1P2": "The Service Provider operates exclusively in the homes of private individuals and offers services eligible for the Personal Services (SAP) scheme, in accordance with the provisions of Article L. 7231-1 of the Labor Code.",
    "art2Title": "Article 2 - Intervention and Audit Modalities",
    "art2_1Title": "2.1. The Mandatory Initial Audit",
    "art2_1P1": "Any new membership is subject to a physical or videoconference audit beforehand at the Client's home. This audit makes it possible to define the level of requirement, the surface area, the nature of the materials (marble, rare woods, leather) and the specific specifications. The audit gives rise to the issuance of a free personalized quote.",
    "art2_2Title": "2.2. Key Handover and Security",
    "art2_2P1": "The Client entrusting a set of keys to the Service Provider signs a key handover register. The keys are anonymized and kept in a biometric safe by management. The Service Provider guarantees absolute security of access.",
    "art3Title": "Article 3 - Pricing and Billing",
    "art3_1Title": "3.1. Rates",
    "art3_1P1": "The rates are communicated including tax (TTC) to the Client during the quote. They depend on the package chosen (Essential, Signature, Absolute) and the recurrence of the interventions.",
    "art3_2Title": "3.2. Immediate Tax Credit Advance (URSSAF)",
    "art3_2P1": "The Service Provider being authorized by URSSAF, the Client can benefit, if eligible, from the Immediate Advance. In this context:",
    "art3_2L1": "The Service Provider creates the Client's URSSAF account with their agreement.",
    "art3_2L2": "The Client validates the registration request.",
    "art3_2L3": "The Service Provider transmits the invoices to URSSAF.",
    "art3_2L4": "URSSAF deducts only the remaining balance (50% of the invoice) from the Client's bank account, up to their annual limit (€12,000, subject to increase).",
    "art3_2Note": "In the event of a malfunction of the URSSAF platform or ineligibility, the entire invoice remains due by the Client to the Service Provider, who will provide them with an annual tax certificate in January of the following year.",
    "art4Title": "Article 4 - Right of Withdrawal",
    "art4P1": "In accordance with Article L.221-18 of the Consumer Code, the Client has a period of 14 clear days to exercise their right of withdrawal from the signing of the contract.",
    "art4P2": "However, if the Client requires the performance of the service to begin before the end of the withdrawal period, they expressly agree to waive their right of withdrawal for the services already performed.",
    "art5Title": "Article 5 - Obligations of the Parties",
    "art5_1Title": "5.1. Commitments of the Service Provider",
    "art5_1P1": "The Service Provider is committed to providing highly qualified personnel, trained in \"palace\" protocols, equipped with their own color-coded microfibers, and bound by a duty of absolute discretion.",
    "art5_2Title": "5.2. Commitments of the Client",
    "art5_2P1": "The Client is committed to guaranteeing secure access to the accommodation, to declare any object of very great value or particularly fragile during the audit, and to notify of any schedule modification at least 48 hours in advance. Any service cancelled outside this period will be billed at 50%.",
    "art6Title": "Article 6 - Liability, Insurance and Breakage",
    "art6P1": "The Service Provider takes out specific Professional Civil Liability insurance covering bodily, material and immaterial damage that could be caused by its workers in the Client's home.",
    "art6P2": "In the event of breakage or damage to a precious object, the Client has 48 hours to inform the Service Provider in writing, with supporting photos. Are excluded from any compensation: normal wear and tear, already weakened objects, or damage related to dilapidated electrical/plumbing installations.",
    "art7Title": "Article 7 - Discretion and Confidentiality",
    "art7P1": "Confidentiality is the cornerstone of our service of excellence. All of the Service Provider's employees sign a strict Non-Disclosure Agreement (NDA). No information concerning the Client's private life, property, or identity will be disclosed. No photograph of the home can be taken outside of the end-of-service photographic report, stored encrypted in the VIP Area.",
    "art8Title": "Article 8 - Duration and Termination",
    "art8P1": "Recurring maintenance contracts are concluded for an indefinite period, with a one-month trial period. After this period, either party may terminate the contract by registered letter or email with acknowledgment of receipt, subject to a one-month notice period.",
    "art9Title": "Article 9 - Applicable Law and Mediation",
    "art9P1": "These General Terms of Sale are subject to French law. In accordance with the Consumer Code, in the event of a dispute, the Client may use the mediation service to which the Service Provider belongs free of charge before any action before the competent courts."
  },
  "legalPage": {
    "headerTitle": "Legal Mentions",
    "headerSubtitle": "& Privacy Policy",
    "lastUpdate": "Last updated: {{date}}",
    "art1Title": "1. Website Publisher",
    "art1P1": "Pursuant to Article 6 of Law No. 2004-575 of June 21, 2004, on confidence in the digital economy (LCEN), users of the <strong>L'Art du Ménage par Johanna</strong> website are informed of the identity of the various parties involved in its creation and monitoring:",
    "art1L1": "<strong>Company name:</strong> L'Art du Ménage (SAS/SARL - <i>To be completed</i>)",
    "art1L2": "<strong>Share capital:</strong> <i>[Capital amount]</i> euros",
    "art1L3": "<strong>Head office:</strong> <i>[Full head office address, e.g., 15 Avenue Montaigne, 75008 Paris]</i>",
    "art1L4": "<strong>RCS:</strong> Registered with the Trade and Companies Register of <i>[City]</i> under number <i>[SIREN number]</i>",
    "art1L5": "<strong>Intra-community VAT number:</strong> <i>[VAT number]</i>",
    "art1L6": "<strong>Email:</strong> contact@lartdumenage.fr",
    "art1L7": "<strong>Phone:</strong> <i>[Phone number]</i>",
    "art2Title": "2. Regulated Activity & Personal Services (SAP)",
    "art2P1": "The company L'Art du Ménage is a declared Personal Services (SAP) organization.",
    "art2L1": "<strong>Declaration Number (NOVA):</strong> SAP<i>[Number to complete]</i>",
    "art2P2": "This declaration allows our clients to benefit from the tax advantage provided for in Article 199 sexdecies of the General Tax Code, namely a reduction or a tax credit equal to 50% of the expenses incurred, within the limit of the regulatory ceilings in force. The company is authorized by URSSAF to offer the <strong>Immediate Tax Credit Advance</strong> (AICI) service, subject to the client's eligibility and registration with the service managed by the Central Agency of Social Security Organizations (ACOSS).",
    "art3Title": "3. Publication Direction & Hosting",
    "art3P1": "<strong>Publication Director:</strong> Madame Johanna <i>[Last name]</i>, acting as President/Manager.<br/>The publication manager is a natural person or a legal entity.",
    "art3P2": "<strong>Website Host:</strong><br/>The site is hosted by Vercel Inc.<br/>Head office: 340 S Lemon Ave #4133 Walnut, CA 91789, USA.<br/>Servers located in the European Union (Paris/Frankfurt Region).",
    "art4Title": "4. Intellectual Property and Counterfeiting",
    "art4P1": "The company L'Art du Ménage is the exclusive owner of the intellectual property rights or holds the rights of use on all the elements accessible on the site, in particular texts, images, graphics, logos, icons, sounds, software and the intervention method described.",
    "art4P2": "Any reproduction, representation, modification, publication, adaptation of all or part of the elements of the site, whatever the means or process used, is strictly prohibited, without prior written authorization from the management of L'Art du Ménage.",
    "art4P3": "Any unauthorized use of the site or of any of the elements it contains will be considered as constituting an infringement and prosecuted in accordance with the provisions of Articles L.335-2 and following of the Intellectual Property Code, engaging the civil and criminal liability of the infringer.",
    "art5Title": "5. Personal Data Processing (GDPR)",
    "art5P1": "In accordance with Law No. 78-17 of January 6, 1978, as amended, relating to computing, files and freedoms, and Regulation (EU) 2016/679 of the European Parliament and of the Council of April 27, 2016 (GDPR), L'Art du Ménage is committed to ensuring the confidentiality and security of the personal data of its clients and prospects.",
    "art5_1Title": "5.1. Nature of data collected",
    "art5_1P1": "The information collected via our forms (audit request, contact, URSSAF registration) includes: last name, first name, postal address, email address, phone number, living area, specific maintenance needs, and bank details (exclusively managed securely for the URSSAF direct debit mandate).",
    "art5_2Title": "5.2. Purpose of processing",
    "art5_2P1": "These data are strictly necessary for the execution of the service contract, customer relationship management (CRM), drawing up quotes and invoices, as well as electronic declaration to URSSAF for the Immediate Advance.",
    "art5_3Title": "5.3. User rights",
    "art5_3P1": "Any user has a right of access, rectification, erasure (right to be forgotten), limitation, opposition and portability of their personal data. To exercise these rights, the user can send a written request by email to the Data Protection Officer (DPO): <strong>dpo@lartdumenage.fr</strong>, accompanied by a copy of a valid identity document.",
    "art6Title": "6. Consumer Mediation",
    "art6P1": "In accordance with the provisions of Articles L. 611-1 and following of the Consumer Code, any consumer has the right to have recourse free of charge to a consumer mediator with a view to the amicable resolution of the dispute between them and a professional.",
    "art6P2": "In the event of a dispute not resolved by our customer service, you can contact the competent mediator: <i>[Name of the mediation entity, ex: La Médiation de l'Assurance or CM2C]</i>, whose contact details are: <i>[Address and website of the mediator]</i>.",
    "art7Title": "7. Limitation of Liability",
    "art7P1": "L'Art du Ménage strives to provide as accurate information as possible on the site. However, the company cannot be held responsible for omissions, inaccuracies and shortcomings in updating, whether caused by itself or by third-party partners who provide this information.",
    "art7P2": "The site uses JavaScript technology. The company cannot be held responsible for material damage related to the use of the site. In addition, the site user agrees to access it using recent equipment, not containing viruses and with an updated latest generation browser.",
    "art8Title": "8. Applicable Law and Jurisdiction",
    "art8P1": "Any dispute in connection with the use of the site is subject to French law. Except in cases where the law does not allow it, exclusive jurisdiction is granted to the competent courts of the jurisdiction of the head office of L'Art du Ménage."
  },
  "blog": {
    "headerTitle": "Our Work",
    "headerSubtitle": "Advice & Methods",
    "sectionTitle": "The Art of Excellence",
    "sectionDesc": "Discover the secrets of our housekeepers, our exclusive methods for caring for noble materials, and our advice for cultivating harmony in your interior.",
    "readArticle": "Read the article",
    "backToBlog": "Back to articles",
    "articles": [
      {
        "id": "secret-des-palaces-aeration",
        "title": "The secret of palaces: The art of air purification",
        "excerpt": "Even before touching a surface, excellence begins with the invisible. Discover why the aeration protocol is the cornerstone of our method.",
        "category": "Methodology",
        "date": "June 12, 2026",
        "image": "/assets/rules/rule4.webp",
        "content": "In luxury hotels, the first sense engaged by a client when entering their suite is not sight, but smell. A stuffy room, even if visually immaculate, immediately loses its aura of prestige.\n\nAt L'Art du Ménage, our protocol requires systematic aeration of at least 15 minutes before starting any service. This not only evacuates volatile organic compounds (VOCs) but also sanitizes the work environment.\n\nWe combine this aeration with the use of purifying essential oils, sprayed sparingly on textiles (if compatible). The goal is not to mask odors with heavy synthetic perfumes, but to create a neutral, fresh, and soothing olfactory signature."
      },
      {
        "id": "entretenir-le-marbre",
        "title": "How to maintain marble without altering it?",
        "excerpt": "A noble material par excellence, marble is also one of the most fragile. Our advice for cleaning it while preserving its natural shine.",
        "category": "Material Care",
        "date": "June 05, 2026",
        "image": "/assets/rules/rule5.webp",
        "content": "Marble is a porous limestone. It is this composition that gives it its unique veins, but it is also what makes it vulnerable to acid attacks.\n\nThe absolute rule of our housekeepers: banish white vinegar, lemon, or any classic anti-limescale product on marble. A single drop is enough to attack the polished layer and leave an indelible matte stain.\n\nOur method is based on the exclusive use of neutral pH soaps (such as real black soap, heavily diluted) and extremely soft microfibers. To restore its shine, a dry buffing with a chamois leather or a specific microfiber is enough. In case of a grease stain, Sommières earth remains your best ally: apply, leave to absorb for 24 hours, and brush gently."
      },
      {
        "id": "code-couleur-microfibres",
        "title": "The microfiber color code: stopping contamination",
        "excerpt": "Why using the same cloth for the bathroom and the kitchen is a health aberration. Explanation of our strict protocol.",
        "category": "Hygiene",
        "date": "May 28, 2026",
        "image": "/assets/rules/rule2.webp",
        "content": "This is a fundamental hygiene rule often ignored in traditional housekeeping: the management of cross-contamination.\n\nOur staff is equipped with a color-coded microfiber set. Red for sanitary facilities, Yellow for the bathroom, Green for the kitchen, and Blue for dust and general surfaces. This system ensures that a bacterium present on the toilet will never end up on your kitchen worktop.\n\nIn addition, our microfibers are washed at a minimum of 60°C with a textile disinfectant, without fabric softener (which destroys their electrostatic and absorbent power). This attention to detail is what separates amateur cleaning from an excellent service."
      },
      {
        "id": "dresser-un-lit-au-cordeau",
        "title": "Making a bed to perfection: housekeepers' tips",
        "excerpt": "Discover the 'hospital corner' technique for a bed worthy of the greatest Parisian palaces.",
        "category": "Bedroom & Linen",
        "date": "May 15, 2026",
        "image": "/assets/luxury_interior.webp",
        "content": "A perfectly made bed is an invitation to a restful sleep. The 'hospital corner' technique is required of all our housekeepers.\n\n1. Tuck the flat sheet under the mattress at the foot of the bed.\n2. Grasp the sheet hanging on the side, about 30 cm from the foot, and lift it to form a 45-degree angle on top of the mattress.\n3. Tuck in the triangular part still hanging at the bottom, then fold the part you were holding over and firmly tuck it under the mattress.\n\nThis folding ensures perfect tension of the sheet. We always finish with a millimeter alignment of the pillows and a smoothing of the duvet to chase away any visual imperfection."
      },
      {
        "id": "ecologie-sans-compromis",
        "title": "Natural waxes vs Chemistry: the ecological requirement",
        "excerpt": "It is possible to combine a perfect cleaning result with total respect for your health and the planet.",
        "category": "Ecology",
        "date": "May 02, 2026",
        "image": "/assets/luxury_gloves.webp",
        "content": "The idea that a product must smell strong and contain aggressive chemicals to be effective is a myth that we deconstruct every day.\n\nIndustrial products often leave a toxic film on your surfaces (tables, worktops, floors where your children play). At L'Art du Ménage, we favor mild chemistry: plant-based surfactants, probiotic cleaners, and natural beeswax or carnauba waxes to nourish wood.\n\nThis approach not only protects your lungs and your skin, but it also extends the lifespan of your noble materials which are often slowly 'burned' by the aggressiveness of bleach or ammonia."
      },
      {
        "id": "soin-du-cuir",
        "title": "Leather care: hydration and protection",
        "excerpt": "A leather sofa is not cleaned, it is nourished. Our secrets to avoid cracking and preserve the patina.",
        "category": "Material Care",
        "date": "April 18, 2026",
        "image": "/assets/luxury_interior.webp",
        "content": "Leather is a living material. Like human skin, if it is not cleaned and hydrated, it dries out, dulls, and eventually cracks.\n\nFor routine maintenance, our housekeepers simply use a barely damp soft cloth to dust, because dust acts as a microscopic abrasive in the folds of the leather.\n\nTwo to three times a year, we apply a deep care protocol: cleaning with leather soap (to open the pores), followed by a massage with a specific nourishing cream (based on lanolin or beeswax). The result? Supple leather that regains its deep color and better resists daily stains."
      },
      {
        "id": "importance-inspection-finale",
        "title": "The final inspection: the 15-minute rule",
        "excerpt": "To err is human. This is why the last step of our protocol is exclusively dedicated to control.",
        "category": "Methodology",
        "date": "April 04, 2026",
        "image": "/assets/rules/rule7.webp",
        "content": "One of the biggest differences between our service and a standard service lies in the management of the end of the intervention.\n\nOur teams have strict orders to stop any cleaning activity 15 minutes before the end of their shift. This quarter of an hour is dedicated to 'stepping back'. The housekeeper goes through each room, not with a cloth, but with her eyes.\n\nShe checks the reflections on the windows and mirrors, ensures that the fittings shine under the light, perfectly replaces the chairs, aligns the cushions, and checks that all lights are off and the doors locked. It is this stepping back that guarantees our 'zero defect' result."
      },
      {
        "id": "argenterie-et-cuivres",
        "title": "Silverware and copper: reviving them without scratching them",
        "excerpt": "How to restore the shine to your precious pieces without using destructive abrasive pastes.",
        "category": "Goldsmithing",
        "date": "March 20, 2026",
        "image": "/assets/luxury_interior.webp",
        "content": "Oxidation is the enemy of silverware and copper, but commercial products are often too abrasive and scratch the metal in the long term, gradually removing the solid silver layer.\n\nWe favor gentle methods. For silverware, a paste made of Meudon white and a little water, applied with a chamois cloth, works miracles without micro-scratches. Rinsing must be immediate and drying meticulous.\n\nTo prevent the oxidation of your exposed display pieces, the secret lies in very regular dusting, because the accumulation of dust accelerates the chemical reaction of silver oxidation."
      },
      {
        "id": "symetrie-et-rangement",
        "title": "Symmetry in tidying: a peaceful mind",
        "excerpt": "Visual order has a direct impact on your mental load. The rule of parallelism explained.",
        "category": "Lifestyle",
        "date": "March 05, 2026",
        "image": "/assets/rules/rule6.webp",
        "content": "A space can be clinically clean, if it is messy, the impression of chaos persists. The psychology of space teaches us that our brain is constantly looking for patterns and geometric order.\n\nOur housekeepers are trained in 'squaring up'. The magazines on the coffee table are aligned parallel to the edges of the table. The sofa cushions are symmetrical. The chairs are replaced equidistantly.\n\nThis geometric rigor instantly transforms the atmosphere of a room. When you get home, this absolute order immediately tells your brain that it can relax. This is the true definition of a luxury service: anticipating your psychological well-being."
      },
      {
        "id": "salles-de-bain-robinetterie",
        "title": "Bathrooms: the secret to sparkling fittings",
        "excerpt": "How to eliminate limescale without destroying the chrome or gold finishes of your bathroom.",
        "category": "Material Care",
        "date": "February 18, 2026",
        "image": "/assets/rules/rule1.webp",
        "content": "Tartar and limescale quickly dull bathrooms, but powerful anti-limescale products end up pitting chrome, blackening brass, or oxidizing the gold of high-end fittings.\n\nThe protocol of L'Art du Ménage relies on prevention and gentleness. We use solutions based on highly diluted citric acid (less aggressive than the hydrochloric acid of industrial products) which we never leave on for more than a few minutes.\n\nThe crucial step is not the product anyway, but the drying. A fitting will never really shine if it is not meticulously wiped dry with a finishing microfiber after rinsing. It is this final polishing that makes all difference."
      }
    ]
  },
  "landing": {
    "title": "The standard of a 5-star hotel service, directly in your home",
    "subtitle": "You pay for peace of mind, not to manage household staff.",
    "methods": [
      {
        "title": "Custom Assessment",
        "desc": "A complete audit of your needs and precious materials."
      },
      {
        "title": "Autonomy & Discretion",
        "desc": "Our staff manages everything from A to Z. Zero mental load."
      },
      {
        "title": "Hotel Standards",
        "desc": "A level of excellence and finishing worthy of the greatest palaces."
      }
    ],
    "footer": {
      "copyright": "© {{year}} L'art du Ménage. All rights reserved."
    },
    "floatingCta": "Book my free audit"
  }
}